<template>
  <div class="page about">
    <navigation
      :theme="{
        background:
          'linear-gradient(90deg,rgba(255,51,51,1) 0%,rgba(255,95,52,1) 100%)',
        color: '#fff',
      }"
    >关于我们</navigation>
    <div class="header">
      <img src="./images/logo.png" />

      <div class="title">{{isWxMiniProcess?'天美贷极速借':'天美贷'}}</div>
      <div class="slogan">优质的金融服务平台</div>
    </div>

    <div class="content">
      <div class="title">
        <div class="label"></div>
        提供合规低息的金融服务
      </div>

      <p>
        {{isWxMiniProcess?'天美贷极速借':'天美贷'}}以互联网安全技术及大数据挖掘、智能严密的风控技术为支点，为用户提供及时可得、安全合规的普惠金融产品。
      </p>
      <p>
        作为一站式综合金融服务平台，天美贷提供额度申请、信用借款等多种专属定制服务，满足消费者们合理的消费需求，同时也倡导用户理性消费、适度借贷。
      </p>

      <div class="title">
        <div class="label"></div>
        服务安全高效
      </div>
      <p>
        我们拥有独立的产品、技术、风控、催收和市场运营团队，以互联网信贷业务为主要战略布局，着眼于满足新兴互联网平台、移动支付和电商购物场景用户的消费信贷需求。
      </p>

      <div class="title">
        <div class="label"></div>
        关注公众号
      </div>
      <p>
        关注天美贷公众号，获得更多公众号专属福利。
      </p>
      <div class="public-account">
        <img
          src="./images/icon_weixin.png"
          srcset="
                        ./images/icon_weixin@2x.png 2x,
                        ./images/icon_weixin@3x.png 3x
                    "
        />
        <span class="text">微信搜索 {{publicAccount}}</span>
        <span class="button" @click="copy">复制</span>
      </div>

      <!-- <img
                src="./images/img_0.png"
                srcset="./images/img_0@2x.png 2x, ./images/img_0@3x.png 3x"
            /> -->

    </div>

    <div class="service">
      <img src="./images/img_fuwu.png" alt="">
    </div>
    <div class="partners">
      <img src="./images/img_hezuofang.png" alt="">
    </div>
    <div @click="jumpPrivacy" class="privacy" v-if="!isWxMiniProcess">
      <a>天美贷隐私政策</a>
    </div>

    
  </div>
</template>
 
<script>
import { copyToClipbord, isWxMiniprogram } from '@/assets/utils'
export default {
  name: 'about',
  data () { return { publicAccount: 'ct_tmd', nu: navigator.userAgent, isWxMiniProcess: isWxMiniprogram() } },
  // mounted () {
  //   this.riskReport(3)
  // },
  methods: {
    copy () {
      copyToClipbord(this.publicAccount)
      this.$message('已复制到剪贴板')
      this.$report({
        id: 10142
      })
    },
    jumpPrivacy () {
      this.routerToProtocol('/tmd/protocol/privacy')
    }
  }
}
</script>

<style lang="less">
@import "../../assets/less/mixin.less";

.about {
    background-color: #fafafa;
    // padding-bottom: 45px;
    .privacy{
        padding:64px 0 85px;
        text-align:center;
        a{
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #8EB2D8;
            line-height: 33px;
            text-decoration: underline;
        }
    }
    .header {
        height: 580px;
        background: url('./images/bg_about us.png') center center no-repeat;
        background-size: 100% 100%;
        overflow: hidden;
        text-align: center;
        color: #ffffff;

        img {
            height: 100px;
            width: 100px;
            margin-top: 72px;
        }

        .title {
            line-height: 45px;
            font-size: 32px;
            margin-top: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
        }

        .slogan {
            font-size: 24px;
            line-height: 33px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
        }
    }

    .content {
        margin: -220px 30px 0;
        padding: 0 35px 90px;
        border-radius: 20px;
        background-color: #ffffff;
        overflow: hidden;

        .title {
            display: flex;
            margin-top: 90px;
            font-size: 32px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            .label {
                width: 12px;
                height: 44px;
                background: linear-gradient(
                    180deg,
                    rgba(255, 179, 92, 1) 0%,
                    rgba(253, 122, 22, 1) 100%
                );
                margin-right: 14px;
            }
        }

        p {
            margin-top: 30px;
            font-size: 24px;
            line-height: 33px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @fc2;
        }
        > img {
            display: block;
            width: 610px;
            height: 130px;
            margin-top: 48px;
        }
        .public-account {
            display: flex;
            align-items: center;
            height: 88px;
            font-size: 28px;
            color: @fc2;
            padding: 0 20px;
            margin-top: 26px;
            > img {
                width: 36px;
                height: 30px;
                margin-right: 20px;
            }
            .text {
                flex: 1;
            }
            .button {
                color: #90b3d8;
            }
        }
    }

    .service {
        margin:25px 30px 0px 30px;
        img {
            height: 310px;
        }
    }

    .partners {
        margin:25px 30px 0px 30px;
        img {
            height: 460px;
        }
    }
}
</style>
